import * as React from 'react'
import Map, { Marker } from 'react-map-gl'
import RoomIcon from '@mui/icons-material/Room'
import 'mapbox-gl/dist/mapbox-gl.css'

const MAPBOX_TOKEN =
  'pk.eyJ1IjoiaGVhbHRoLW9zIiwiYSI6ImNsZW85eWY3bTAwYzUzc29kaXoyM2ZlOXEifQ.uxsmDjyE89vcXYaW69rPHA' // Set your mapbox token here

function MapOverview() {
  const [viewState, setViewState] = React.useState({
    latitude: 53.958333,
    longitude: -1.080278,
    zoom: 14,
  })

  return (
    <Map
      {...viewState}
      onMove={(evt) => setViewState(evt.viewState)}
      style={{ width: 750, height: 600 }}
      mapStyle="mapbox://styles/mapbox/streets-v9"
      mapboxAccessToken={MAPBOX_TOKEN}
    >
      <Marker latitude={53.957333} longitude={-1.081237}>
        <RoomIcon />
      </Marker>
      <Marker latitude={53.958333} longitude={-1.080278}>
        <RoomIcon />
      </Marker>
      <Marker latitude={53.959833} longitude={-1.089937}>
        <RoomIcon />
      </Marker>
      <Marker latitude={53.957033} longitude={-1.089078}>
        <RoomIcon />
      </Marker>
    </Map>
  )
}

export default MapOverview
